import { useFlowQuery } from '@twisto/api-graphql'
import { Loader } from '@twisto/components/atoms/loader'

import { useFlow } from '../../flow/flow.context'

import * as styles from './bank-account-connection-processing-step.styles'

/**
 *
 * @deprecated use ProcessingStep instead
 */
export const BankAccountConnectionProcessingStep = () => {
  const { sessionId } = useFlow()
  const { stopPolling } = useFlowQuery({
    pollInterval: 1000,
    variables: {
      auth: {
        sessionId,
      },
    },
    onCompleted: (data) => {
      if (
        data.flow?.currentStep.__typename !==
        'BankAccountConnectionProcessingStep'
      ) {
        stopPolling()
      }
    },
  })

  return (
    <div css={styles.root}>
      <Loader />
    </div>
  )
}
